"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.perfNow = void 0;
var perfNow = function () {
    return window.performance && window.performance.now ? window.performance.now() : Date.now();
};
exports.perfNow = perfNow;
//# sourceMappingURL=perfNow.js.map